import Typography from "../../ui/widgets/typography";
import Info from "../../ui/widgets/info";
import InputContainer from "../../ui/layout/page/forms-container/form-item-container/input-container";
import TextInputField from "../shared/components/formik/text-input";
import { useMessageSource } from "react-message-source";
import SectionFullWidthContainer from "../../ui/layout/page/forms-container/section-full-width-container";

export const SecurityCode = () => {
  const { getMessage } = useMessageSource();

  return (
    <SectionFullWidthContainer hasAdditionalTopMargin>
      <Typography variant="h4" className="scd-container-base-small">
        {getMessage("CompanyOnline.securityCode-title")}
      </Typography>
      <Info title={getMessage("CompanyOnline.securityCode.info-label")}>
        {getMessage("CompanyOnline.securityCode.info")}
      </Info>
      <InputContainer>
        <TextInputField
          id="companyOnlineSecurityCode"
          name="companyOnlineSecurityCode"
          label={getMessage("CompanyOnline.securityCode")}
          helperUnderInput={getMessage(
            "CompanyOnline.securityCode-helperUnderInput",
          )}
        />
      </InputContainer>
    </SectionFullWidthContainer>
  );
};
